"use strict";

module.exports = {
  id: "includeCredentials",
  before: function before(req) {
    // Enable sending Cookies for authentication.
    // Ref: https://fetch.spec.whatwg.org/#concept-request-credentials-mode
    req.credentials = "same-origin";
  }
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/marty/dist/node/lib/stateSource/inbuilt/http/hooks/includeCredentials.js
 ** module id = 491
 ** module chunks = 0
 **/